import axios from '../request/wxAxios'
import { axiosNoToken } from '../request/pcAxios'
import store from '@/store'
class Login {
  // 获取登录二维码
  static getWechatQRCode () {
    return axios.get('/customer/public/auth/getWechatNftQRCode')
  }
  // 通过二维码登录网页
  static loginFromWeb (checkCode) {
    return axios.get('/customer/public/auth/loginFromWeb', {
      params: {
        checkCode
      }
    })
  }
  // 完成网页登录（通知后端）
  static completeWebLogin (eid) {
    const dpexToken = store.state.token
    return axios.get('/customer/public/auth/completeWebLogin', {
      params: {
        eid,
        'dpex-token': dpexToken
      }
    })
  }
  // 获取登录手机号验证码
  static getVerificationCode (params) {
    return axiosNoToken.post('customer/public/auth/getVerificationCode', params)
  }
  // 通过手机号登录
  static loginWithMobile (params) {
    return axiosNoToken.post('/customer/public/auth/loginWithMobile', params)
  }
  // 完成网页登录（通知后端）
  static completeMobileLogin (eid) {
    const dpexToken = store.state.token
    return axios.get('/customer/public/auth/completeMobileLogin', {
      params: {
        eid,
        'dpex-token': dpexToken
      }
    })
  }
}

export default Login